export default __webpack_public_path__ + "static/media/web.59e10845.png";